// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"667d3a57","461":"22d5843f","787":"f669abf5","934":"c8fc33b5"}[chunkId] + ".chunk.js";
};